<template>
    <div
        class="book-insights-discover"
        :class="{ 'hidden' : showReaderMode }"
    >
        <start-membership />
        <main>
            <transition name="slide-down-thanks">
                <bi-thanks v-if="sourceRoute === 'newsLetterSubscription'" :background="require('@assets/img/book-insights/computer-girl.png')">
                    <template #title>
                        Thank you for Subscribing
                    </template>
                    <template #content>
                        <p>You will now receive new Book Insights each day.<br>Not seeing our emails? Check your spam folder!</p>
                        <p>Meanwhile, please check out our previous newsletters below.</p>
                    </template>
                    <template #link>
                        <a class="text-primary" href="" @click.prevent="() => sourceRoute = ''">
                            Discover Book Insights
                        </a>
                    </template>
                </bi-thanks>
            </transition>
            <transition name="slide-down-thanks">
                <bi-thanks v-if="sourceRoute === 'nonFictionSubscription'" :background="require('@assets/img/book-insights/computer-boy.png')">
                    <template #title>
                        You're in!
                    </template>
                    <template #content>
                        <p>You now have unlimited access to our entire (and ever growing!) collection of Book Insights.</p>
                        <p>
                            Manage your membership on the
                            <router-link :to="{ name: 'membership' }" class="text-primary">
                                profile
                            </router-link>
                            page, and access your saved Book Insights in your
                            <router-link :to="{ name: 'bi-library' }" class="text-primary">
                                library
                            </router-link>
                            .
                        </p>
                    </template>
                    <template #link>
                        <a
                            href=""
                            class="text-primary"
                            @click.prevent="() => sourceRoute = ''"
                        >Browse all Book Insights</a>
                    </template>
                </bi-thanks>
            </transition>
            <transition-group name="slide-in" tag="div">
                <!-- <div v-if="featuredInsightIsEmpty" :key="Number(featuredBookinsight.id)" class="container">
                    <section>
                        <h1>This Week’s Book Insight</h1>
                        <book-insight-hero-group
                            :book-insight="featuredBookinsight"
                        />
                    </section>
                </div> -->

                <div v-if="freeBookInsights.length" key="free-bi-carousel" class="container">
                    <section>
                        <bi-carousel :books-insights="freeBookInsights">
                            <h2 slot="title">
                                Book Insights
                            </h2>
                            <p slot="description">
                                Read or listen to a few of our best Book Insights.
                            </p>
                        </bi-carousel>
                    </section>
                </div>

                <div v-if="recentlyAddedInsights.length" key="recently-added-bi-carousel" class="container">
                    <section>
                        <bi-carousel :books-insights="recentlyAddedInsights">
                            <h2 slot="title">
                                New Book Insights
                            </h2>
                            <p slot="description">
                                Listen to our recently added Book Insights.
                            </p>
                        </bi-carousel>
                    </section>
                </div>

                <template v-for="genre in genres">
                    <div v-if="genre.bookInsights.length" :key="Number(genre.id)" class="container">
                        <section>
                            <bi-carousel :books-insights="genre.bookInsights">
                                <h2 slot="title">
                                    {{ genre.name }}
                                </h2>
                                <p v-show="genre.description" slot="description">
                                    {{ genre.description }}
                                </p>
                            </bi-carousel>
                        </section>
                    </div>
                </template>
            </transition-group>
        </main>
        <memod-footer />
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
    name: "BooksInsightsDiscover",
    metaInfo() {
        return {
            titleTemplate: "Discover - %s"
        }
    },
    components: {
        // bookInsightHeroGroup: () => import(/* webpackChunkName: "book-insight-hero-group"*/ "@c/books-insights/hero-group"),
        biCarousel: () => import(/* webpackChunkName: "bi-carousel"*/ "@c/books-insights/carousel"),
        biThanks: () => import(/* webpackChunkName: "bi-thanks"*/ "@c/books-insights/thanks"),
        memodFooter: () => import(/* webpackChunkName: "memod-footer"*/ "@v/memod-footer"),
        startMembership: () => import(/* webpackChunkName: "start-membership"*/ "@c/books-insights/modals/start-membership")
    },
    data() {
        return {
            nonfictionBaseUrl: process.env.VUE_APP_NONFICTION_BASE_API_URL,
            sourceRoute: this.$route.params.sourceRoute,
            timeStampFormat: "YYYY-MM-DD HH:mm:ss"
        };
    },
    computed: {
        ...mapState({
            showReaderMode: state => state.NonfictionReader.showReaderMode,
            accessTypeIds: state => state.AccessTypes.idList,
            freeBookInsights: state => state.InsightsDiscover.freeBookInsights,
            featuredBookinsight: state => state.InsightsDiscover.featuredBookinsight,
            recentlyAddedInsights: state => state.InsightsDiscover.recentlyAddedInsights,
            genres: state => state.InsightsDiscover.genres
        }),
        ...mapGetters({
            isLoggedIn: "User/isLoggedIn",
            isEmptyDiscover: "InsightsDiscover/isEmptyDiscover",
            featuredInsightIsEmpty: "InsightsDiscover/featuredInsightIsEmpty"
        }),
        thankYouBackground() {
            const nonFictionThanksBackground = require("@assets/img/book-insights/computer-boy.png");
            const newsletterSubscriptionBackground = require("@assets/img/book-insights/computer-girl.png");
            return sourceRoute === "newsLetterSubscription" ?
                newsletterSubscriptionBackground : nonFictionThanksBackground;
        }
    },
    created() {
        if (this.$route.name == "subscription-book-insights-welcome" && this.sourceRoute != "nonFictionSubscription") {
            this.$router.replace({ name: "bi-discover" });
        }
        if (this.isEmptyDiscover) {
            this.$store.dispatch("Application/showLoader", true);
        }
        this.fetchAll();
        this.$store.dispatch("Application/setSelectedNonfictionGift", {});
    },
    methods: {
        fetchAll() {
            const featuredBookInsightPromise = this.fetchFeaturedBookinsight();
            const genresBookInsightsPromise = this.getGenreBookInsights();
            const freeBookInsights = this.fetchFreeBookInsights();
            const recentlyAddedInsights = this.fetchRecentlyAddedInsights();

            Promise.all([
                featuredBookInsightPromise,
                genresBookInsightsPromise,
                freeBookInsights,
                recentlyAddedInsights
            ]).finally(() => {
                this.$store.dispatch("Application/showLoader", false);
            });
        },
        async getGenreBookInsights() {
            return await axiosCms.get(`/site/genres?sort=weight|desc`).then(async({ data }) => {
                const genresDirectory = {};
                const genres = data.map((genre, index) => {
                    genresDirectory[genre.id] = index;
                    genre.bookInsights = [];
                    return genre;
                })
                await this.$store.dispatch("InsightsDiscover/updateGenres", { genres, genresDirectory });
            });
        },
        async fetchFeaturedBookinsight() {
            return await this.$store.dispatch("InsightsDiscover/updateFeaturedBookinsight");
        },
        async fetchFreeBookInsights() {
            const freeBookInsightsparams = `?q=(access_type:${this.accessTypeIds.FREE})`;
            return await this.$store.dispatch("InsightsDiscover/updateFreeBookInsights", freeBookInsightsparams);
        },
        async fetchRecentlyAddedInsights() {
            const currentDate = moment().utc().format(this.timeStampFormat);
            const monthAgoDate = moment().utc().add(-30, "days").format(this.timeStampFormat);
            const freeBookInsightsparams = `?q=(published_at<${currentDate},published_at>${monthAgoDate})`;
            return await this.$store.dispatch("InsightsDiscover/updateRecentlyAddedInsights", freeBookInsightsparams);
        }
    }
}
</script>

<style lang="scss">
.book-insights-discover {
    .container {
        @media (max-width: $sm) {
            overflow: hidden;
        }

        section {
            margin-bottom: 0;

            .bi-carousel {
                .swiper-container {
                    @media (max-width: 470px) {
                        width: 120%;
                    }

                    @media (max-width: 400px) {
                        width: 135%;
                    }

                    @media (max-width: 350px) {
                        width: 160%;
                    }
                }
            }
        }

    }

    main {
        margin-bottom: 50px;
    }

     &.hidden {
        overflow: hidden;
        height: 100vh;
    }
}
</style>
